<template>
  <el-menu
    :default-active="index"
    class="el-menu-vertical-demo"
    @open="() =>{}"
    @close="() =>{}"
    @select="selectRouter"
    background-color="#ece4ce"
    text-color="#000"
    active-text-color="#409EFF"
    :router="true"
    :collapse="!collapse"
    :collapse-transition="false"
  >
    <el-menu-item index="/home">
      <svg-icon icon-class="sy" />
      <span class="menuName" slot="title">首页</span>
    </el-menu-item>

    <el-submenu :index="d.path" v-for="d in list" :key="d.menuName">
      <template slot="title">
        <svg-icon :icon-class="d.icon" />
        <span class="menuName" slot="title">{{d.menuName}}</span>
      </template>
      <el-menu-item
        :index="'/' + d2.path"
        v-for="d2 in d.children"
        :key="d2.menuName"
      >{{d2.menuName}}</el-menu-item>
      <!-- <el-menu-item index="/interview">走访任务</el-menu-item>
      <el-menu-item index="/detection">农残检测</el-menu-item>-->
    </el-submenu>

    <!-- <el-submenu index="2">
      <template slot="title">
        <i class="el-icon-location"></i>
        <span slot="title">采购管理</span>
      </template>
      <el-menu-item index="/plan">采购计划</el-menu-item>
    </el-submenu>

    <el-submenu index="3">
      <template slot="title">
        <i class="el-icon-location"></i>
        <span slot="title">采摘管理</span>
      </template>
      <el-menu-item index="/taskPick">采摘任务</el-menu-item>
      <el-menu-item index="/transport">鲜果运输</el-menu-item>
      <el-menu-item index="/warehouse">鲜果进仓</el-menu-item>
    </el-submenu>

    <el-submenu index="4">
      <template slot="title">
        <i class="el-icon-location"></i>
        <span slot="title">加工管理</span>
      </template>
      <el-menu-item index="/skin">出皮统计</el-menu-item>
    </el-submenu>

    <el-submenu index="5">
      <template slot="title">
        <i class="el-icon-location"></i>
        <span slot="title">溯源管理</span>
      </template>
      <el-menu-item index="/print">标签打印</el-menu-item>
    </el-submenu>

    <el-submenu index="6">
      <template slot="title">
        <i class="el-icon-location"></i>
        <span slot="title">库管理</span>
      </template>
      <el-menu-item index="/logistics">物流运输供应商管理</el-menu-item>
      <el-menu-item index="/village">行政区域管理</el-menu-item>
    </el-submenu>

    <el-submenu index="7">
      <template slot="title">
        <i class="el-icon-location"></i>
        <span slot="title">系统管理</span>
      </template>
      <el-menu-item index="/account">账户管理</el-menu-item>
      <el-menu-item index="/organMsg">部门管理</el-menu-item>
      <el-menu-item index="/menu">菜单管理</el-menu-item>
      <el-menu-item index="/role">角色权限管理</el-menu-item>
      <el-menu-item index="/dick">字典管理</el-menu-item>
    </el-submenu>-->
  </el-menu>
</template>
<script >
export default {
  data() {
    return {
      collapse: true,
      index: '',
      list: [],
    }
  },
  props: {
    sidebar: {
      type: Boolean,
      default: true,
    },
    active: {
      type: String,
      default: '',
    },
  },
  watch: {
    sidebar: {
      handler(val) {
        console.log(val, '---------------会刷新吗')
        this.collapse = val
      },
    },
    active: {
      handler(val) {
        this.index = val
      },
    },
  },
  created() {
    this.index = this.$router.currentRoute.path
    let menuList = JSON.parse(sessionStorage.getItem('menuList'))
    this.list = this.handleTree(
      menuList.filter((item) => item.visible == 0 && item.menuType != 'F'),
      'id'
    )
    // console.log(this.list, 'this.list')
  },
  methods: {
    selectRouter(val) {
      this.$emit('pushRouter', { path: val})
    },
  },
}
</script>
<style lang="less" scoped>
.menuName {
  margin-left: 2px;
}
/deep/.el-submenu__title {
  text-align: left;
}
/deep/ .el-menu-item,
.el-submenu__title {
  text-align: left;
}
/deep/.el-submenu__title i {
  color: #000;
}
/deep/.el-menu-item i {
  color: #000;
}
/deep/ .el-aside {
  height: 859px;
  overflow: auto;
}
</style>